import { useState, useEffect } from 'react'

interface ContentItem {
  id: string
  title: string
  description: string
  type: 'presentation' | 'pdf' | 'image' | 'video' | 'markdown'
  accessLevel: 'demo' | 'company' | 'admin'
  companyId?: string
  companyName?: string
  createdAt: string
  updatedAt: string
  thumbnailUrl?: string
}

interface ContentResponse {
  content: ContentItem[]
  total: number
}

interface UsePlatformContentResult {
  content: ContentItem[]
  loading: boolean
  error: string | null
  refetch: () => void
}

export function usePlatformContent(): UsePlatformContentResult {
  const [content, setContent] = useState<ContentItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchContent = async () => {
    setLoading(true)
    setError(null)

    try {
      const token = localStorage.getItem('token')
      if (!token) {
        throw new Error('No authentication token found')
      }

      const response = await fetch('http://localhost:3000/api/content', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

      if (!response.ok) {
        throw new Error('Failed to fetch platform content')
      }

      const data: ContentResponse = await response.json()
      setContent(data.content || [])
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred')
      console.error('Error fetching platform content:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchContent()
  }, [])

  return { content, loading, error, refetch: fetchContent }
}

export type { ContentItem, ContentResponse, UsePlatformContentResult }
